import {getLeftToLeft, getTopToTop} from "../../../../domain/composition";
import {getLidSize, getSubFloorManholeMinOverlap} from "../../../../domain/lid";
import {getIntermediateCeilingSize} from "../../../../domain/intermediateCeiling";
import {getVaultSize} from "../../../../domain/vault";
import {Line, DashedLine} from "../../../Renderer/primitives";
import React from "react";
import {renderVaultOutlineBehindRects} from "./renderer";
import {SubFloorManhole} from "./SubFloorManhole";
import {createLidGeometry} from "./lidGeometry";

const round = val => Math.round(100 * val) / 100

export const SubFloorLid = ({plan, scale}) => {
    const lidGeometry = createLidGeometry(plan, plan.manholes, scale)
    console.log('lidGeometry', lidGeometry, plan, scale)
    // Lid
    const getLidTop = () => !!plan.intermediateCeiling ?
        (getTopToTop(getLidSize, [getLidSize, getIntermediateCeilingSize], plan)) * scale :
        plan.lid.type === 'subfloor' && !!plan.vault ?
            (getTopToTop(getLidSize, [getLidSize, plan => getVaultSize(plan, false)], plan)) * scale :
            0
    const getLidHeight = () => getLidSize(plan).width * scale
    const getLidBottom = () => getLidTop() + getLidHeight()
    const getLidLeft = () => !!plan.intermediateCeiling ?
        getLeftToLeft(getLidSize, [getLidSize, getIntermediateCeilingSize], plan) * scale :
        plan.lid.type === 'subfloor' && !!plan.vault ?
            getLeftToLeft(getLidSize, [getLidSize, plan => getVaultSize(plan, false)], plan) * scale :
            0
    const getLidWidth = () => getLidSize(plan).length * scale
    const getLidRight = () => getLidLeft() + getLidWidth()

    // Clear measure (vault)
    const getClearMeasureLeft = () => getLidLeft() - getLidSize(plan).x * scale
    const getClearMeasureLength = () => plan.length * scale
    const getClearMeasureRight = () => getClearMeasureLeft() + getClearMeasureLength()
    const getClearMeasureFront = () => getLidTop() + (getLidSize(plan).width + getLidSize(plan).y) * scale
    const getClearMeasureWidth = () => plan.width * scale
    const getClearMeasureBack = () => getClearMeasureFront() - getClearMeasureWidth()



    // Manhole
    const hasManhole = () => plan.lid && plan.lid.manholes.length === 1

    const renderLidOutline = () => {
        return <Line points={[getLidLeft(),
            getLidTop(),
            getLidLeft(),
            getLidBottom(),
            getLidRight(),
            getLidBottom(),
            getLidRight(),
            getLidTop(),
            getLidLeft(),
            getLidTop()]}/>
    }

    const manhole = plan.lid.manholes[0]

    const getManholeLeft = () => round(getClearMeasureLeft() + manhole.x * scale)
    const getManholeWidth = () => round(manhole.width * scale)
    const getManholeRight = () => round(getManholeLeft() + getManholeWidth())
    const getManholeBottom = () => round(getClearMeasureFront() - manhole.y * scale)
    const getManholeHeight = () => round(manhole.height * scale)
    const getManholeTop = () => round(getManholeBottom() - getManholeHeight())

    const renderVaultClearMeasure = () => <DashedLine points={[getClearMeasureLeft(),
        getClearMeasureFront(),
        getClearMeasureLeft(),
        getClearMeasureBack(),
        getClearMeasureRight(),
        getClearMeasureBack(),
        getClearMeasureRight(),
        getClearMeasureFront(),
        getClearMeasureLeft(),
        getClearMeasureFront()]}/>

    const renderIntermediateCeilingsClearMeasure = () => {
        const getMinOverlap = () => getSubFloorManholeMinOverlap() * scale
        const getXWithinClearMeasure = x => {
            return Math.min(getClearMeasureRight(), Math.max(getClearMeasureLeft(), x))
        }
        const getYWithinClearMeasure = y => {
            return Math.max(getClearMeasureBack(), Math.min(getClearMeasureFront(), y))
        }
        return manhole.orientation === 'vertical' ? <React.Fragment>
            <DashedLine points={[getXWithinClearMeasure(getManholeLeft()),
                getYWithinClearMeasure(getManholeTop() + getMinOverlap()),
                getXWithinClearMeasure(getManholeRight()),
                getYWithinClearMeasure(getManholeTop() + getMinOverlap())]}/>
            <DashedLine points={[getXWithinClearMeasure(getManholeLeft()),
                getYWithinClearMeasure(getManholeBottom() - getMinOverlap()),
                getXWithinClearMeasure(getManholeRight()),
                getYWithinClearMeasure(getManholeBottom() - getMinOverlap())]}/>
            {getManholeLeft() <
                getClearMeasureLeft() &&
                <DashedLine points={[getXWithinClearMeasure(getManholeLeft()),
                    getYWithinClearMeasure(getManholeTop() + getMinOverlap()),
                    getXWithinClearMeasure(getManholeLeft()),
                    getYWithinClearMeasure(getManholeBottom() - getMinOverlap()),]}/>}
            {getManholeRight() >
                getClearMeasureRight() &&
                <DashedLine points={[getXWithinClearMeasure(getManholeRight()),
                    getYWithinClearMeasure(getManholeTop() + getMinOverlap()),
                    getXWithinClearMeasure(getManholeRight()),
                    getYWithinClearMeasure(getManholeBottom() - getMinOverlap()),]}/>}
        </React.Fragment> : <React.Fragment>
            <DashedLine points={[getXWithinClearMeasure(getManholeLeft() + getMinOverlap()),
                getYWithinClearMeasure(getManholeTop()),
                getXWithinClearMeasure(getManholeLeft() + getMinOverlap()),
                getYWithinClearMeasure(getManholeBottom()),]}/>
            <DashedLine points={[getXWithinClearMeasure(getManholeRight() - getMinOverlap()),
                getYWithinClearMeasure(getManholeTop()),
                getXWithinClearMeasure(getManholeRight() - getMinOverlap()),
                getYWithinClearMeasure(getManholeBottom()),]}/>
            {getManholeTop() <
                getClearMeasureBack() &&
                <DashedLine points={[getXWithinClearMeasure(getManholeLeft() + getMinOverlap()),
                    getYWithinClearMeasure(getManholeTop()),
                    getXWithinClearMeasure(getManholeRight() - getMinOverlap()),
                    getYWithinClearMeasure(getManholeTop()),]}/>}
            {getManholeBottom() >
                getClearMeasureFront() &&
                <DashedLine points={[getXWithinClearMeasure(getManholeLeft() + getMinOverlap()),
                    getYWithinClearMeasure(getManholeBottom()),
                    getXWithinClearMeasure(getManholeRight() - getMinOverlap()),
                    getYWithinClearMeasure(getManholeBottom()),]}/>}
        </React.Fragment>
    }

    return (<React.Fragment>
        {!plan.intermediateCeiling && renderVaultClearMeasure()}

        {!!hasManhole() ? renderVaultOutlineBehindRects(
            {
                x: lidGeometry.vaultLeft,
                y: lidGeometry.vaultBack,
                w: lidGeometry.vaultRight - lidGeometry.vaultLeft,
                h: lidGeometry.vaultFront - lidGeometry.vaultBack
            },
            [{
                x: getManholeLeft(), y: getManholeTop(), w: getManholeWidth(), h: getManholeHeight()
            }],
            !plan.vault && !plan.intermediateCeiling
        ) : renderLidOutline()}
        {!!hasManhole()
            && <SubFloorManhole lidGeometry={lidGeometry} scale={scale} manhole={plan.lid.manholes[0]} />
        }
        {!!hasManhole() && !!plan.intermediateCeiling && renderIntermediateCeilingsClearMeasure()}
    </React.Fragment>)
}
